/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { StaticTelemetry, LogLevel } from '@msdyn365-commerce/telemetry-internal';

/**
 * Logs structured telemetry with custom tags and exception.
 *
 * @param logLevel - LogLevel.Error | LogLevel.Warning | LogLevel.Information
 * @param messageTemplate - Message with placeholders like "Error in {function} of {module}"
 * @param error - The actual Error object
 * @param customTags - Custom tags like { module: 'checkout', function: 'submitEmail' }
 * @param values - Placeholder values for the message
 */
export function logCheckoutError(
    logLevel: LogLevel,
    messageTemplate: string,
    error: Error,
    customTags?: Record<string, string>,
    values?: Record<string, string | number>
): void {
    const tags = customTags ? Object.entries(customTags).map(([key, val]) => `${key}:${val}`) : [];

    StaticTelemetry.log(logLevel, messageTemplate, {
        exception: error,
        customTags: tags
    });
}
